export default __webpack_public_path__ + "static/media/casual-shoes.3371191b.webp";